/* esm.sh - tablesort@5.7.1/src/sorts/tablesort.number */
export * from "/tablesort@5.7.1/es2022/src/sorts/tablesort.number.mjs";
export { default } from "/tablesort@5.7.1/es2022/src/sorts/tablesort.number.mjs";
